/**
 * ローディングエフェクト表示
 */
function loadStart (type) {
  var elemId = type
  if ([undefined, null, ''].includes(type)) elemId = 'loading'
  console.log('loadStart', elemId)
  const e = document.getElementById(elemId)
  if (e === null) { return }
  e.style.display = ''
}

/**
 * ローディングエフェクト非表示
 */
function loadComplete (type) {
  const e = document.getElementById('loading')
  if (e !== null) {
    e.style.display = 'none'
  }
  const e2 = document.getElementById('loading2')
  if (e2 !== null) {
    e2.style.display = 'none'
  }
}

export default {
  loadStart,
  loadComplete
}
